import { render, staticRenderFns } from "./CelebrationDetails.vue?vue&type=template&id=6602d454"
import script from "./CelebrationDetails.vue?vue&type=script&lang=js"
export * from "./CelebrationDetails.vue?vue&type=script&lang=js"
import style0 from "./CelebrationDetails.vue?vue&type=style&index=0&id=6602d454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports